import React, { memo, useMemo } from 'react';
import AnchorLink from 'ls-common-client/dist/components/AnchorLink';
import Anchor from 'ls-common-client/dist/components/Anchor';
import EmptyButton from 'ls-common-client/dist/components/EmptyButton';
import config from '../../src/client/config';
import hasMigrated from '../utils/routeMatcher';
import appendUTMParams from '../utils/utmParams';

const NextLink = ({ external, to, children, onClick, ...props }) => {
  const finalTo = useMemo(() => appendUTMParams(to || ''), [to]);

  if (onClick) {
    return (
      <EmptyButton onClick={onClick} {...props}>
        {children}
      </EmptyButton>
    );
  }

  if (external) {
    return (
      <Anchor href={finalTo} target="_blank" {...props}>
        {children}
      </Anchor>
    );
  }

  return hasMigrated(finalTo) ? (
    <Anchor href={`${config.v2UrlRoot}${finalTo}`} {...props}>
      {children}
    </Anchor>
  ) : (
    <AnchorLink to={finalTo} {...props}>
      {children}
    </AnchorLink>
  );
};

export default memo(NextLink);
